import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTitle } from "../../components/TitleContext";
import { useAvailableTranslation } from "../../hooks/translation/useAvailableTranslations";
import TableData from "../../components/ui/Table";
import { getTranslationPhaseColumns, getTranslationPhaseHiddenColumns } from "./TranslationPhaseColumns";
import useAuth from "../../hooks/useAuth";
import { useAcceptTranslationReview } from "../../hooks/translation/useAcceptTranslationReview";
import { useRefuseTranslationReview } from "../../hooks/translation/useRefuseTranslationReview";
import { usePromptDialog } from "../../hooks/useConfirm";
import { TranslationMode } from "../../api/fetchTranslationLabels";
import { Translation } from "../../model/Translation";

const TranslationPhases = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const { data: translationData, isLoading, isError } = useAvailableTranslation();
  const acceptTranslationReview = useAcceptTranslationReview();
  const refuseTranslationReview = useRefuseTranslationReview();
  const promptDialog = usePromptDialog();
  const { setTitle, setSubtitle } = useTitle();
  const handleTranslation = (translation: Translation, mode: TranslationMode) => {
    navigate(`/translation/${translation.id}/${mode}`, { state: { translation } });
  };

  const handleAcceptTranslationReview = (translationId: number) => {
    acceptTranslationReview.mutate(translationId);
  };

  const handleRefuseTranslationReview = async (translationId: number) => {
    const refuseReason = await promptDialog({
      title: "Refuse Translation",
      message: "Enter a reason to refuse the translation :",
      placeholder: "Reason ...",
      required: true,
    });
    if (refuseReason) {
      refuseTranslationReview.mutate({
        translationId: translationId,
        refuseReason: refuseReason,
      });
    }
  };

  useEffect(() => {
    setTitle("Translation Phases");
    setSubtitle("");
    return () => {};
  }, [setTitle]);

  return (
    <div className="container justify-start max-w-7xl">
      <div className="flex flex-col gap-4">
        <h2 className="text-xl font-display font-bold p-4"> Available Translations</h2>
        <TableData
          tableName="translationPhaseTable"
          rows={translationData || []}
          columns={getTranslationPhaseColumns(
            handleTranslation,
            handleTranslation,
            handleAcceptTranslationReview,
            handleRefuseTranslationReview,
            auth.roles
          )}
          hiddenColumns={getTranslationPhaseHiddenColumns()}
          pageSize={[10, 15, 25, 50]}
        ></TableData>
      </div>
    </div>
  );
};

export default TranslationPhases;
